.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
  background-color: var(--color-overlay);
  overflow-y: auto;
  animation: backdrop-in var(--duration-normal) var(--ease-out);
}

.top {
  align-items: flex-start;
  padding-top: min(12vh, 7rem);
}

.dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100dvh - 2 * var(--space-4));
  background-color: var(--color-surface-raised);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  animation: dialog-in var(--duration-slow) var(--ease-out);
}

.top .dialog {
  max-height: calc(100dvh - min(12vh, 7rem) - var(--space-4));
}

.dialog:focus-visible {
  outline: none;
}

.sm {
  max-width: 26rem;
}

.md {
  max-width: 34rem;
}

.lg {
  max-width: 48rem;
}

.xl {
  max-width: 64rem;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-5) var(--space-5) var(--space-3);
}

.headerHidden {
  padding: 0;
}

.headings {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  margin: calc(-1 * var(--space-1)) calc(-1 * var(--space-1)) 0 0;
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
}

.close:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.closeIcon {
  transform: rotate(45deg);
}

.body {
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-2) var(--space-5) var(--space-5);
  overflow-y: auto;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-5);
  border-top: 1px solid var(--color-border);
  background-color: var(--color-surface-sunken);
  border-radius: 0 0 var(--radius-xl) var(--radius-xl);
}

@media (max-width: 480px) {
  .backdrop {
    align-items: flex-end;
    padding: 0;
  }

  .top {
    align-items: flex-start;
    padding: var(--space-2);
  }

  .dialog {
    max-height: 92dvh;
    border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  }

  .footer {
    flex-direction: column-reverse;
    align-items: stretch;
    border-radius: 0;
  }
}

@keyframes backdrop-in {
  from {
    opacity: 0;
  }
}

@keyframes dialog-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
}
